import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomChevronRight({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M5.5 1a.517.517 0 00-.354.14.457.457 0 000 .67L13.793 10l-8.647 8.192a.457.457 0 000 .67.52.52 0 00.707 0l9-8.527a.457.457 0 000-.67l-9-8.527A.513.513 0 005.5 1H5.5z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgIconCustomChevronRight;
